export default __webpack_public_path__ + "static/media/location_icon.5f36e311.svg";